import { Mesh } from '@pixi/mesh';
import './settings.mjs';
import { settings } from '@pixi/core';

let warned = false;
Mesh.prototype._cachedTint = 16777215;
Mesh.prototype._tintedCanvas = null;
Mesh.prototype._cachedTexture = null;
Mesh.prototype._renderCanvas = function _renderCanvas(renderer) {
  if (this.shader.uvMatrix) {
    this.shader.uvMatrix.update();
    this.calculateUvs();
  }
  if (this.material._renderCanvas) {
    this.material._renderCanvas(renderer, this);
  } else if (!warned) {
    warned = true;
    if (globalThis.console) {
      console.warn("Mesh with custom shaders are not supported in CanvasRenderer.");
    }
  }
};
Mesh.prototype._canvasPadding = null;
Object.defineProperty(Mesh.prototype, "canvasPadding", {
  get() {
    return this._canvasPadding !== null ? this._canvasPadding : settings.MESH_CANVAS_PADDING;
  },
  set(value) {
    this._canvasPadding = value;
  }
});
//# sourceMappingURL=Mesh.mjs.map
